import type { IconProps } from './index';
import type { ReactElement } from 'react';

import { Svg } from './styles';
import { colors } from '../styles';

const HamburgerIcon = ({ color = colors.BLACK, hoverColor }: IconProps): ReactElement => (
  <Svg viewBox="0 0 24 25" $hoverColor={hoverColor}>
    <g fill={color}>
      <path
        fillRule="nonzero"
        fillOpacity="1"
        stroke="none"
        d="M21 12.5a.75.75 0 0 1-.75.75H3.75a.75.75 0 1 1 0-1.5h16.5a.75.75 0 0 1 .75.75ZM3.75 7.25h16.5a.75.75 0 1 0 0-1.5H3.75a.75.75 0 0 0 0 1.5Zm16.5 10.5H3.75a.75.75 0 1 0 0 1.5h16.5a.75.75 0 1 0 0-1.5Z"
      />
    </g>
  </Svg>
);

export default HamburgerIcon;
